/** Global Figma-aligned design tokens (Disha Foundation) */

export const colors = {
  navy: '#082753',
  cream: '#fffefa',
  text: '#111',
  textSecondary: 'rgba(17,17,17,0.6)',
  textMuted: 'rgba(17,17,17,0.8)',
  textOnNavy: '#fffefa',
  textOnNavyMuted: 'rgba(255,254,250,0.8)',
  headerBg: 'rgba(248, 249, 250, 0.95)',
  footerBg: 'rgba(8, 39, 83, 0.06)',
  divider: 'rgba(0, 0, 0, 0.12)',
}

export const radius = {
  input: 8,
  icon: 10,
  thumb: 12,
  cardMobile: 16,
  card: 20,
  button: 50,
}

export const shadow = {
  card: '0px 0px 8px 0px rgba(0,0,0,0.12)',
}

export const button = {
  desktopHeight: 45,
  desktopFontSize: 16,
  desktopPaddingX: 20,
  mobileHeight: 41,
  mobileFontSize: 13,
}
